export enum EEventType {
  'In Person',
  'Virtual'
 }